// extracted by mini-css-extract-plugin
export default {"tupacGrid":"cn-z","tupacHeader":"dn-z","tupacHeader2":"en-z","tupacMenu":"fn-z","tupacMenu2":"gn-z","tupacMain":"hn-z","tupacMain2":"in-z"};